export default __webpack_public_path__ + "static/media/hbs-k-blk-4.955f3519.png";